// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import Vuex from 'vuex'
import VueResource from 'vue-resource'
import VueMoment from 'vue-moment'
import { TOGGLE_SIDEBAR } from '@/store/mutation-types'
import router from './router'

Vue.router = router

Vue.use(Vuex)
Vue.use(VueResource)

import moment from 'moment'
import 'moment/locale/es'

Vue.use(VueMoment, { moment })

import App from './App'

import { BASE_URL } from './config'

Vue.config.productionTip = false
Vue.http.options.root = BASE_URL
Vue.http.options.emulateJSON = true

Vue.http.interceptors.push(function (request, next) {
  var token = window.localStorage.getItem('token')
  if (token) {
    request.headers.set('Authorization', 'Bearer ' + token)
  }
  next(function (response) {
    if (response.status === 401) {
      console.error('No valid session')
      this.$router.push({name: 'login'})
    }
  })
})

import VeeValidate, { Validator } from 'vee-validate'
import es from 'vee-validate/dist/locale/es'

Validator.localize({ 'es': es })
Vue.use(VeeValidate, { locale: 'es' })

import store from '@/store'

import '@/components/navbar'
import '@/components/sidebar'
import '@/components/message-system'

const { state } = store

router.beforeEach((route, redirect, next) => {
  if (state.app.device.isMobile && state.app.sidebar.opened) {
    store.commit(TOGGLE_SIDEBAR, false)
  }
  next()
})

/* eslint-disable no-new */
new Vue({
  store,
  el: '#app',
  router,
  template: '<App/>',
  components: { App }
})



// WEBPACK FOOTER //
// ./src/main.js